module.exports = __webpack_public_path__ + "img/backtop.2db488e5.png";